import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { groupsApi, type GroupSummary } from '../lib/domain';

export function GroupsPage() {
  const [groups, setGroups] = useState<GroupSummary[]>([]);
  const [name, setName] = useState('');

  function reload() {
    groupsApi.list().then((r) => setGroups(r.groups));
  }

  useEffect(reload, []);

  async function create() {
    if (!name.trim()) return;
    await groupsApi.create(name.trim());
    setName('');
    reload();
  }

  return (
    <div className="stack">
      <h1>Gruppen</h1>
      <p className="muted">
        Neu hier? Die <Link to="/guide">Anleitung</Link> zeigt, welche Schritte nach dem Anlegen einer Gruppe sinnvoll sind.
      </p>
      <div className="card row">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Neue Gruppe" />
        <button className="primary" onClick={create}>
          Anlegen
        </button>
      </div>
      <ul className="list-reset stack">
        {groups.map((g) => (
          <li key={g.id} className="card">
            <Link to={`/groups/${g.id}`}>
              <strong>{g.name}</strong>
            </Link>
            <div className="muted">
              {g.role === 'ADMIN' ? 'Admin' : 'Mitglied'} · Community-Freigabe {g.communityOptIn ? 'an' : 'aus'}
            </div>
          </li>
        ))}
        {groups.length === 0 && <p className="muted">Noch keine Gruppen.</p>}
      </ul>
    </div>
  );
}
